$(document).ready(function()
{
    $('#mobile-trigger').on('click', function(e)
    {
        e.preventDefault();
        $('#MobileNav').toggle();
        $(this).toggleClass('open');
    });


    // Mega dropdown
    var targetLink = '/collections/all-products';
    var target = $('header ul.site-nav a[href="' + targetLink + '"]');
    var megaMenu = $('#mega-dropdown');

    var hoverCount = 0;
    var tolerance = 100; // delay to check if anything is active

    target.on('mouseenter', function()
    {
        hoverCount++;
        megaMenu.trigger('open');
    })
        .on('mouseleave', function()
        {
            hoverCount--;
            megaMenu.trigger('close');
        });

    megaMenu.on('mouseenter', function()
    {
        hoverCount++;
    })
        .on('mouseleave', function()
        {
            hoverCount--;
            megaMenu.trigger('close');
        });

    megaMenu.on('open', function()
    {
        $(this).show();
    })
        .on('close', function()
        {
            // Check if it's okay to close
            setTimeout(function()
            {
                if (hoverCount <= 0)
                {
                    hoverCount = 0; // just in case
                    megaMenu.hide();
                }
            }, tolerance);
        })


});